import { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.target);
    const data = {
      nome: formData.get('user_name'),
      email: formData.get('user_email'),
      telefone: formData.get('user_phone'),
      tipo_evento: formData.get('event_type'),
      mensagem: formData.get('message')
    };

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbzRSyeZ1FbEsT38eVky2RrQa0PD4sFNqiKwnAvRdkQI4cc6yBSzB7W87Uoe4pp6evL5AA/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(data).toString()
        }
      );

      setShowModal(true);
      e.target.reset();
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const Modal = () => (
    <div className="contact__modal" onClick={() => setShowModal(false)}>
      <div className="contact__modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="contact__modal-icon">
          <i className="fas fa-check-circle"></i>
        </div>
        <h3>Mensagem Enviada!</h3>
        <p>Agradecemos seu contato. Nossa equipe entrará em contato em até 24 horas úteis.</p>
        <p className="contact__modal-sub">Enquanto isso, siga-nos no Instagram para ver nossos projetos:</p>
        <div className="contact__modal-actions">
          <a
            href="https://www.instagram.com/acjlocacoes/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__instagram-btn"
          >
            <i className="fab fa-instagram"></i>
            Seguir @acjlocacoes
          </a>
          <button onClick={() => setShowModal(false)} className="contact__close-btn">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section id="contato" className="contact">
      <div className="section-container">
        <div className="contact__wrapper">
          <div className="contact__info" data-aos="fade-right">
            <span className="section-label">Fale Conosco</span>
            <h2>Pronto para transformar seu <span>próximo projeto</span>?</h2>
            <p className="contact__subtitle">
              Solicite um orçamento sem compromisso. Nossa equipe responde em até 24h
              com uma proposta personalizada para seu projeto.
            </p>

            <div className="contact__channels">
              <a href="https://wa.me/5531972035157" target="_blank" rel="noopener noreferrer" className="contact__channel">
                <div className="contact__channel-icon contact__channel-icon--whatsapp">
                  <i className="fab fa-whatsapp"></i>
                </div>
                <div>
                  <h4>WhatsApp</h4>
                  <span>(31) 97203-5157</span>
                </div>
              </a>


              <div className="contact__channel">
                <div className="contact__channel-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div>
                  <h4>Localização</h4>
                  <span>Belo Horizonte, MG</span>
                </div>
              </div>
            </div>

            <div className="contact__guarantees">
              <div className="contact__guarantee">
                <i className="fas fa-shield-alt"></i>
                <span>Orçamento sem compromisso</span>
              </div>
              <div className="contact__guarantee">
                <i className="fas fa-clock"></i>
                <span>Resposta em até 24h</span>
              </div>
              <div className="contact__guarantee">
                <i className="fas fa-thumbs-up"></i>
                <span>Melhor custo-benefício</span>
              </div>
            </div>
          </div>

          <div className="contact__form-wrapper" data-aos="fade-left">
            <form onSubmit={handleSubmit} className="contact__form">
              <h3>Solicite seu orçamento</h3>

              <div className="contact__form-row">
                <div className="contact__field">
                  <label htmlFor="user_name">Nome completo</label>
                  <input
                    type="text"
                    id="user_name"
                    name="user_name"
                    placeholder="Seu nome"
                    required
                  />
                </div>

                <div className="contact__field">
                  <label htmlFor="user_phone">Telefone</label>
                  <input
                    type="tel"
                    id="user_phone"
                    name="user_phone"
                    placeholder="(31) 99999-9999"
                    required
                  />
                </div>
              </div>

              <div className="contact__field">
                <label htmlFor="user_email">Email</label>
                <input
                  type="email"
                  id="user_email"
                  name="user_email"
                  placeholder="seu@email.com"
                  required
                />
              </div>

              <div className="contact__field">
                <label htmlFor="event_type">Tipo de projeto</label>
                <select id="event_type" name="event_type" required>
                  <option value="">Selecione o tipo de projeto</option>
                  <option value="corporate">Evento Corporativo</option>
                  <option value="show">Show ou Festival</option>
                  <option value="social">Casamento / Evento Social</option>
                  <option value="shopping">Shopping / Varejo</option>
                  <option value="church">Igreja / Evento Religioso</option>
                  <option value="advertising">Publicidade / Outdoor Digital</option>
                  <option value="fair">Feira / Exposição</option>
                  <option value="other">Outro</option>
                </select>
              </div>

              <div className="contact__field">
                <label htmlFor="message">Detalhes do evento</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Conte sobre seu evento: data, local, número de pessoas, tamanho desejado do painel..."
                  rows="4"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="contact__submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i>
                    Enviar Solicitação
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {showModal && <Modal />}
    </section>
  );
};

export default ContactForm;
